export const ConstantList = {
  ENTER_KEY: "Enter",
};
export enum SELECT_OPTION {
  SELECT_ACTION = "select-option",
  CLEAR_ACTION = "clear",
  REMOVE_ACTION = "remove-value",
}

export const PERMISSIONS = {
  AUTHORITY: "AUTHORITY",
  MODULE: "MODULE",
  ADMIN: "ADMIN",
}

export const AUTHORITIES = {
  ACCESS: {
    SYSTEM: "ACCESS.SYSTEM",
    USER: "ACCESS.USER",
    ORGANIZATION: "ACCESS.ORGANIZATION",
    ROLE: "ACCESS.ROLE",
    AUTHORITY: "ACCESS.AUTHORITY",
    DEPARTMENT: "ACCESS.DEPARTMENT"
  },

  AUTHORITY : {
    VIEW: "AUTHORITY.VIEW",
    CREATE: "AUTHORITY.CREATE",
    UPDATE: "AUTHORITY.UPDATE",
    DELETE: "AUTHORITY.DELETE",
    UPLOAD: "AUTHORITY.UPLOAD",
  },

  ROLE : {
    VIEW: "ROLE.VIEW",
    CREATE: "ROLE.CREATE",
    UPDATE: "ROLE.UPDATE",
    DELETE: "ROLE.DELETE",
    UPLOAD: "ROLE.UPLOAD",
  },

  USER : {
    VIEW: "USER.VIEW",
    CREATE: "USER.CREATE",
    UPDATE: "USER.UPDATE",
    DELETE: "USER.DELETE",
    UPLOAD: "USER.UPLOAD",
  },

  ORGANIZATION : {
    VIEW: "ORGANIZATION.VIEW",
    CREATE: "ORGANIZATION.CREATE",
    UPDATE: "ORGANIZATION.UPDATE",
    DELETE: "ORGANIZATION.DELETE",
    UPLOAD: "ORGANIZATION.UPLOAD",
  },

  DEPARTMENT : {
    VIEW: "DEPARTMENT.VIEW",
    CREATE: "DEPARTMENT.CREATE",
    UPDATE: "DEPARTMENT.UPDATE",
    DELETE: "DEPARTMENT.DELETE",
    UPLOAD: "DEPARTMENT.UPLOAD",
  },

  FACULTY : {
    VIEW: "FACULTY.VIEW",
    CREATE: "FACULTY.CREATE",
    UPDATE: "FACULTY.UPDATE",
    DELETE: "FACULTY.DELETE",
    UPLOAD: "FACULTY.UPLOAD",
  },

  CHAMBER : {
    VIEW: "CHAMBER.VIEW",
    CREATE: "CHAMBER.CREATE",
    UPDATE: "CHAMBER.UPDATE",
    DELETE: "CHAMBER.DELETE",
    UPLOAD: "CHAMBER.UPLOAD",
  },

  BED : {
    VIEW: "BED.VIEW",
    CREATE: "BED.CREATE",
    UPDATE: "BED.UPDATE",
    DELETE: "BED.DELETE",
    UPLOAD: "BED.UPLOAD",
  },

  PERSON : {
    VIEW: "PERSON.VIEW",
    CREATE: "PERSON.CREATE",
    UPDATE: "PERSON.UPDATE",
    DELETE: "PERSON.DELETE",
    UPLOAD: "PERSON.UPLOAD",
  },

  SERVICE : {
    VIEW: "SERVICE.VIEW",
    CREATE: "SERVICE.CREATE",
    UPDATE: "SERVICE.UPDATE",
    DELETE: "SERVICE.DELETE",
    UPLOAD: "SERVICE.UPLOAD",
  },

  EQUIPMENT : {
    VIEW: "EQUIPMENT.VIEW",
    CREATE: "EQUIPMENT.CREATE",
    UPDATE: "EQUIPMENT.UPDATE",
    DELETE: "EQUIPMENT.DELETE",
    UPLOAD: "EQUIPMENT.UPLOAD",
  },

  SUPPLIER : {
    VIEW: "SUPPLIER.VIEW",
    CREATE: "SUPPLIER.CREATE",
    UPDATE: "SUPPLIER.UPDATE",
    DELETE: "SUPPLIER.DELETE",
    UPLOAD: "SUPPLIER.UPLOAD",
  },

  CATEGORY: {
    VIEW: "CATEGORY.VIEW",
    CREATE: "CATEGORY.CREATE",
    UPDATE: "CATEGORY.UPDATE",
    DELETE: "CATEGORY.DELETE",
    UPLOAD: "CATEGORY.UPLOAD",
  },

  CONFIGURATION: {
    VIEW: "CONFIGURATION.VIEW",
    CREATE: "CONFIGURATION.CREATE",
    UPDATE: "CONFIGURATION.UPDATE",
    DELETE: "CONFIGURATION.DELETE",
    UPLOAD: "CONFIGURATION.UPLOAD",
  },
  
  TERM_MODEL: {
    VIEW: "TERM_MODEL.VIEW",
    CREATE: "TERM_MODEL.CREATE",
    UPDATE: "TERM_MODEL.UPDATE",
    DELETE: "TERM_MODEL.DELETE",
  },

  CACHE: {
    VIEW: "CACHE.VIEW",
    RELOAD: "CACHE.RELOAD",
    CLEAR: "CACHE.CLEAR",
  },
}

export const PERMISSION_ABILITY = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  UPLOAD: "UPLOAD",
  EXPORT: "EXPORT",
}

export const MODULE = {
  HO_SO: "HO_SO",
  TUYEN_DUNG: "TUYEN_DUNG",
  CHAM_CONG: "CHAM_CONG",
  TAI_LIEU: "TAI_LIEU",
  DAO_TAO: "DAO_TAO",
  PHONG_HOP: "PHONG_HOP",
  CONG_VIEC: "CONG_VIEC",
  HE_THONG: "HE_THONG",
  USER: "USER",
}

export const ROLE = {
  USER: "ROLE_USER",
}

export const MODULE_NAME = {
  HO_SO: "profile",
  TUYEN_DUNG: "recruitment",
  CHAM_CONG: "timekeeping",
  TAI_LIEU: "document",
  DAO_TAO: "trainning",
  PHONG_HOP: "meeting-room",
  CONG_VIEC: "job",
  HE_THONG: "system"
}

export const PATH_ROUTES = {
  SYSTEM: {
    DEFAULT: "/system/user",
    USER: "/system/user",
    ROLE: "/system/role",
    AUTHORITY: "/system/authority",
    ORGANIZATION: "/system/organization",
    DEPARTMENT: "/system/department",
    FACULTY: "/system/faculty",
    CHAMBER: "/system/chamber",
    BED: "/system/bed",
    PERSON: "/system/person",
    SERVICE: "/system/service",
    EQUIPMENT: "/system/equipment",
    SUPPLIER: "/system/supplier",
    PACKAGE: "/system/package",
    CATEGORY: "/system/category",
    CONFIGURATION: "/system/configuration",
    TERM_MODEL: "/system/term-model",
    TERM_FORM_BUILDER: "/system/term-form-builder/:id",
    TERM_FORM_BUILDER_CREATE: "/system/term-form-builder",
    WF_CONFIG: "/system/workflows",
    CACHE: "/system/cache",
  }
}

export const PAGINATION = {
  PAGE_INDEX_DEFAULT: 0,
  PAGE_SIZE_DEFAULT: 10,
  TOTAL_PAGE_DEFAULT: 10,
  TOTAL_ELEMENTS_DEFAULT: 0,
  NUMBER_OF_ELEMENTS_DEFAULT: 0,
}

export const VARIABLE = {
  FUNCTION_CONSTANT: {
    ERROR_MESSAGE: "errorMessage",
    MESSAGE: "message",
  },

  DEFAULT_PASSWORD: "12345678"
}

export const SCREEN = {
  TABLET_WIDTH: 992
}

export const DATE_FORMAT = {
  TABLE: "DD/MM/YYYY",
  ISO_DATE: "YYYY-MM-DDTHH:mm:ss"
}

export const TABLE_FIELD = {
  ACTION: "action",
  STT: "stt",
}

export const RESPONSE_CODE = {
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  METHOD_NOT_ALLOWED: 405,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  BAD_GATEWAY: 502,
}

export const GRID = {
  ONE_ITEM_PER_LINE: 12,
  TWO_ITEM_PER_LINE: 6,
  THREE_ITEM_PER_LINE: 4,
  FOUR_ITEM_PER_LINE: 3,
}

export const REDIRECT_PATH = {
  NOT_FOUND: "/error/404",
  HOME: "/home-x",
}

export const DELETE_TYPE = {
  SINGLE_DELETE: 1,
  DELETE_ALL: 2,
}

export const APP_CONFIGURATION_KEYS = {
  ADMIN_URL: 'adminUrl',
  EMR_URL: 'emrUrl',
  EMR_INTEGRATION_URL: 'integrationUrl',
  API_URL: "apiUrl",
  SSO_URL: 'ssoUrl',
  WAREHOUSE_URL: 'wmsUrl',
  INS_URL: 'insUrl',
  INPATIENT_URL: 'inpatientUrl',
  API_REPORT_URL: 'apiReportUrl',
  OAUTH_CLIENT_URL: 'oauthClientUrl',
  APPLICATION_NAME: 'applicationName',
  FAVICON: 'favicon',
  WEB_CLIENT_URL: "webClientUrl",
  LOGO: "logo",
  LOGO_PRIMARY: "logoPrimary",
  LOGO_SMALL: "logoSmall",
  BACKGROUND: "background",
  SPLASH_SCREEN_IMAGE: "splashScreenImage",
  QUALITY_MANAGEMENT: "qualityManagementUrl",
  HOMEPAGE: "homepage",
  IS_CATEGORY: "isCategory",
  END_WITH_NAME: "Name",
  WORKFLOW_STATUS_URL: 'workflowStatusUrl',
  WORKFLOW_TRACKER_URL: 'workflowTrackerUrl',
  WORKFLOW_API_URL: 'workflowApiUrl',
  POWERED_BY: 'poweredBy',
  MENU_BY_ROLE: 'showMenuByRole',
  APP_DOCUMENT_TITLE: 'appDocumentTitle',
}

// Predefined keys for tenant configuration - dropdown selection
export const PREDEFINED_TENANT_CONFIG_KEYS = [
  // Image keys
  { key: 'logo', label: 'Logo', type: 'image', important: true, order: 1 },
  { key: 'logoPrimary', label: 'Logo Primary', type: 'image', important: true, order: 2 },
  { key: 'logoSmall', label: 'Logo thu nhỏ', type: 'image', important: true, order: 3 },
  { key: 'favicon', label: 'Favicon', type: 'image', important: true, order: 4 },
  { key: 'splashScreenImage', label: 'Splash Screen Image', type: 'image', important: true, order: 5 },
  { key: 'background', label: 'Background', type: 'image', important: false, order: 6 },

  // Text keys
  { key: 'applicationName', label: 'Tên ứng dụng', type: 'text', important: true, order: 7 },
  { key: 'appDocumentTitle', label: 'Tiêu đề tài liệu', type: 'text', important: false, order: 8 },
  { key: 'poweredBy', label: 'Powered By', type: 'text', important: false, order: 9 },
  { key: 'textColor', label: 'Màu chữ', type: 'color', important: true, order: 10 },
  { key: 'homeTextColor', label: 'Màu chữ trang chủ', type: 'color', important: true, order: 11 },

  // URL keys
  { key: 'homepage', label: 'Trang chủ', type: 'url', important: false, order: 12 },
  { key: 'adminUrl', label: 'Admin URL', type: 'url', important: false, order: 13 },
  { key: 'emrUrl', label: 'EMR URL', type: 'url', important: false, order: 14 },
  { key: 'integrationUrl', label: 'Integration URL', type: 'url', important: false, order: 15 },
  { key: 'apiUrl', label: 'API URL', type: 'url', important: false, order: 16 },
  { key: 'ssoUrl', label: 'SSO URL', type: 'url', important: false, order: 17 },
  { key: 'wmsUrl', label: 'WMS URL', type: 'url', important: false, order: 18 },
  { key: 'insUrl', label: 'Insurance URL', type: 'url', important: false, order: 19 },
  { key: 'inpatientUrl', label: 'Inpatient URL', type: 'url', important: false, order: 20 },
  { key: 'apiReportUrl', label: 'API Report URL', type: 'url', important: false, order: 21 },
  { key: 'oauthClientUrl', label: 'OAuth Client URL', type: 'url', important: false, order: 22 },
  { key: 'webClientUrl', label: 'Web Client URL', type: 'url', important: false, order: 23 },
  { key: 'qualityManagementUrl', label: 'Quality Management URL', type: 'url', important: false, order: 24 },
  { key: 'workflowStatusUrl', label: 'Workflow Status URL', type: 'url', important: false, order: 25 },
  { key: 'workflowTrackerUrl', label: 'Workflow Tracker URL', type: 'url', important: false, order: 26 },
  { key: 'workflowApiUrl', label: 'Workflow API URL', type: 'url', important: false, order: 27 },
]

// Hidden keys that should ALWAYS be hidden (both general and service config)
export const HIDDEN_CONFIG_KEYS = [
  'identityProviders',
  'themeSettings',
  'variables',
  'isCategory',
]

// Hidden keys ONLY for general tenant config (but allowed in service config)
export const HIDDEN_GENERAL_CONFIG_KEYS = [
  'textColor',
  'homeTextColor',
  'logo',
  'logoPrimary',
  'logoSmall',
  'logoHomepage',
  'favicon',
  'splashScreenImage',
  'background',
  'backgroundLogin'
]

export const FILE_EXTENSION = {
  IMAGE: 'image/*',
  PDF: 'application/pdf',
  DOC: 'application/msword',
  DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  EXCEL: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
};

export const FORMIO_FORM_CODE = {
  DANH_MUC_GIUONG: 'danhmucgiuong',
  CAU_HINH_DON_VI: 'cauhinhdonvi',
  CAU_HINH_BO_SUNG_TAI_KHOAN: 'cauhinhbosungtaikhoan',
}

export const BOOLEAN_VALUE = {
  TRUE: "1",
  FALSE: "0",
}